import React from 'react';
import { useLazyLoadQuery } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';

import { ListFacilities, ListFacilitiesProps } from 'deprecated/fragments';

import {
  QueryListFacilitiesQuery,
  QueryListFacilitiesQueryVariables,
} from './__generated__/QueryListFacilitiesQuery.graphql';

export interface QueryListFacilitiesProps extends Omit<ListFacilitiesProps, 'fragmentRef'> {
  variables?: QueryListFacilitiesQueryVariables;
  disabled?: boolean;
}

const QueryListFacilities: React.FC<QueryListFacilitiesProps> = ({ variables = {}, disabled = false, ...rest }) => {
  const data = useLazyLoadQuery<QueryListFacilitiesQuery>(
    graphql`
      query QueryListFacilitiesQuery($regex: String = "") {
        ...ListFacilities_Query @arguments(regex: $regex)
      }
    `,
    variables,
    { fetchPolicy: 'store-or-network' },
  );

  return <ListFacilities disabled={disabled} fragmentRef={data} {...rest} />;
};

export default QueryListFacilities;
